import React from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';

import Item from './Item';

const getProject = (event) =>
  event.data.project ? event.data.project : event.data.memo.project;

const List = ({ title, groupedEvents }) => {
  return (
    <React.Fragment>
      {title && <h3>{title}</h3>}
      <div className="o-layout o-layout--large">
        <div className="o-layout__item u-margin-bottom">
          <div className="c-box c-box-primary">
            {Object.values(groupedEvents).map((events) => (
              <Item
                key={events[0].createdAt}
                events={events}
                // Pull the project from any of the events. It's the same, always.
                project={getProject(events[0])}
              />
            ))}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state, { events }) => {
  const groupedEvents = _.groupBy(events, (event) => {
    if (event.action === 'ADD_PROJECT_MEMO') {
      return event.data.memo.project._id;
    } else {
      return event.data.project._id;
    }
  });

  return { groupedEvents };
};

export default connect(mapStateToProps)(List);



// WEBPACK FOOTER //
// ./src/events/projects/List.js